export const watchMouseOrKeyboard = () => {
  if (typeof document !== "undefined") {
    const addBodyClass = () => {
      if (!document.body.classList.contains("uitk-no-outline")) {
        document.body.classList.add("uitk-no-outline");
        document.body.removeEventListener("mousedown", addBodyClass);
        document.body.addEventListener("keydown", removeBodyClass);
      }
    };
    const removeBodyClass = () => {
      if (document.body.classList.contains("uitk-no-outline")) {
        document.body.classList.remove("uitk-no-outline");
        document.body.removeEventListener("keydown", removeBodyClass);
        document.body.addEventListener("mousedown", addBodyClass);
      }
    };
    addBodyClass();
  }
};
